// extracted by mini-css-extract-plugin
module.exports =  {"container":"b429494557--container--omgHY","logo_img":"b429494557--logo_img--EJ6iO"};